import * as React from "react";

function SvgIcons8InternetExplorer(props, ref) {
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...{ ...props, ref }}>
      <path
        fill="#29B6F6"
        d="M29.4 8.4c1.1-.7 5.3-3.3 8.8-3.3 6.6 0 3.5 7.7 3.5 7.7l.2.2c3.8-9.7-3.5-9-3.5-9-4.1 0-9.3 3.4-10.4 4.2-1-.1-2-.2-3.1-.2C9.7 8 7.4 19.6 7.1 23c-.1.5-.1.8-.1.8V23.7c6.1-8.7 14.5-12.2 14.5-12.2v.6C9 20.6 6 33.2 5.3 35.7c-.8 2.6-.3 8.3 5 8.3s10.4-4.2 10.4-4.2 1.2.2 4.3.2c13.2 0 16.7-12 16.7-12H30s-1.2 4-5.4 4c-5.8 0-5.6-6-5.6-6h23c.4-5.5-1.1-9.3-3.3-11.9-1.8-2.6-4.7-4.8-9.3-5.7zM20 39.6s-7.8 4.9-11.4 1.5c-1.9-3.4 1.2-8.2 1.2-8.2s2.4 4.9 10.2 6.7zm-1.2-29.3s-.1 0 0 0zM19 21s-.1-5 5.5-5c5.4 0 5.5 5 5.5 5H19z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8InternetExplorer);
